(() => {
  if (document.querySelector(".template-product")) {
    document.addEventListener("DOMContentLoaded", () =>
      window.dispatchEvent(new Event("resize"))
    );
    const e = document.querySelectorAll(
        ".boost-pfs-quickview-selector-wrapper"
      ),
      t = document.querySelector(".product__select"),
      o = document.querySelector(".main-form"),
      r = document.querySelector(".product-form__submit"),
      i = document.querySelector(".minus-icon"),
      n = document.querySelector(".plus-icon"),
      a = document.querySelector("#Quantity-sub-main"),
      c = document.querySelectorAll(".product-sku .sku"),
      l = document.querySelector(".main-product__preloader");
    i.addEventListener("click", () => {
      a.value - 1 != 0 && a.setAttribute("value", a.value - 1);
    }),
      n.addEventListener("click", () => {
        parseInt(a.value) && a.setAttribute("value", parseInt(a.value) + 1);
      }),
      o.addEventListener("change", () => {
        l.classList.add("active");
        const e = document.querySelector(".main-product__container"),
          r = e.dataset.section,
          i = e.dataset.url,
          n = +t.value;
        fetch(`${i}?variant=${n}&section_id=${r}`)
          .then((e) => e.text())
          .then((e) => {
            const t = new DOMParser().parseFromString(e, "text/html"),
              r = document.querySelector(".main-product__price"),
              i = t.querySelector(".main-product__price"),
              n = document.querySelector(
                '[data-option-position="1"] .option-title__value'
              ),
              a = t.querySelector(
                '[data-option-position="1"] .option-title__value'
              ),
              c = document.querySelector(
                '[data-option-position="2"] .option-title__value'
              ),
              l = t.querySelector(
                '[data-option-position="2"] .option-title__value'
              ),
              s = document.querySelector(
                '[data-option-position="3"] .option-title__value'
              ),
              d = t.querySelector(
                '[data-option-position="3"] .option-title__value'
              ),
              u = document.querySelector(".product-gallery__thumbs"),
              p = t.querySelector(".product-gallery__thumbs"),
              m = document.querySelector(".product-gallery__main"),
              v = t.querySelector(".product-gallery__main");
            i && r && (r.innerHTML = i.innerHTML),
              a && n && (n.innerHTML = a.innerHTML),
              l && c && (c.innerHTML = l.innerHTML),
              d && s && (s.innerHTML = d.innerHTML),
              u && p && (u.innerHTML = p.innerHTML),
              m && v && (m.innerHTML = v.innerHTML),
              o.dispatchEvent(new Event("update-pdp-gallary", { bubbles: !0 }));
          })
          .finally(() => {
            l.classList.remove("active");
          });
      }),
      e.forEach((e) => {
        const o = e.querySelectorAll(".boost-pfs-swatch-element");
        o.forEach((e, i) => {
          e.addEventListener("click", () => {
            !(function (e, o) {
              e.forEach((e, t) => {
                o != t
                  ? e.classList.remove("is-active")
                  : e.classList.add("is-active");
              });
              const i = document.querySelectorAll(
                ".boost-pfs-swatch-element.is-active"
              );
              var n = "";
              i.forEach((e, t) => {
                n = 0 == t ? e.dataset.handle : `${n} / ${e.dataset.handle}`;
              }),
                (function (e) {
                  Array.from(t).forEach((t) => {
                    t.dataset.title == e &&
                      ((t.selected = !0),
                      c.forEach((e) => {
                        e.dataset.id != t.getAttribute("value")
                          ? e.classList.remove("is-show")
                          : e.classList.add("is-show");
                      }),
                      t.disabled
                        ? (r.setAttribute("disabled", ""),
                          (r.firstElementChild.innerText = "Sold out"))
                        : (r.removeAttribute("disabled", ""),
                          (r.firstElementChild.innerText = "Add to cart")));
                  });
                })(n);
            })(o, i);
          });
        });
      }),
      Array.from(t).forEach((t) => {
        if (t.selected && !t.disabled) {
          const r = t.dataset.title.split(" / ");
          var o = "";
          e.forEach((e, t) => {
            e.querySelectorAll(".boost-pfs-swatch-element").forEach((e, i) => {
              const n = e.getAttribute("data-value");
              n == r[t] && e.classList.add("is-active"),
                0 == t ? 0 == i && (o = `${n}`) : 0 == i && (o = `${o} / ${n}`);
            });
          });
        }
        t.selected &&
          c.forEach((e) => {
            e.dataset.id != t.getAttribute("value")
              ? e.classList.remove("is-show")
              : e.classList.add("is-show");
          });
      });
    const s = document.querySelector(".main-product__accordions");
    s &&
      s.querySelectorAll(".main-product__accordion").forEach((e) => {
        e.querySelector(".title").addEventListener("click", () => {
          e.classList.toggle("active");
        });
      });
  }
})();
